import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { useParams } from "react-router-dom";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { FaPlus } from "react-icons/fa6";
import { FormEvent, useState } from "react";
import ModalButton from "../../../components/common/form/ModalButton";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { FaGlobe, FaTrash } from "react-icons/fa";
import AddEditReswareCredentialsForm from "./modals/AddorEditReswareCredentials";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import { useDeleteReswareCredentialMutation, useSearchReswareCredentialsQuery } from "./integrationsApi";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";

const ReswareCredentials = () => {
    const { customerId } = useParams();
    const [showCredentialModal, setShowCredentialModal] = useState(false);
    const [credentialId, setCredentialId] = useState("");
    const [deleteApi, { isLoading: deleteApiResponse }] = useDeleteReswareCredentialMutation();

    const handleDeleteSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (credentialId) {
            await handleRTKQuery(
                () => deleteApi({ customerId, credentialId }).unwrap(),
                (isSuccess:any) => {
                    if (isSuccess) setCredentialId("");
                }
            );
        }
    };

    const columns: DataTableColumn[] = [
        {
            label: "UserName", accessor: "username",
            cell: (props: any) => (
                <span
                    className="column-link active cursor"
                    style={{ color: "#007BFF", cursor: "pointer" }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setCredentialId(props.row.original.id);
                        setShowCredentialModal(true);
                    }}
                >
                    {props.value}
                </span>
            )
        },
        {
            label: "URL", accessor: "url",
            cell: (props: any) => (
                <a href={props.value} target="_blank" rel="noopener noreferrer">
                    <FaGlobe style={{ cursor: 'pointer', color: '#1E90FF' }} />
                </a>
            )
        },
        { label: "Product Type", accessor: "productType" },
        {
            label: hasPermission(["RESW-D"]) ? "Action" : <span/>,
            accessor: "id",
            canSort: false,
            cell: (props: any) => (
                hasPermission(["RESW-D"]) && props.row.original.id && (
                    <div className="ml-4">
                        <ModalButton
                            triggerButton={
                                <FaTrash
                                    className="cursor-pointer text-surface-0 text-lg hover:text-highlight-7"
                                    title="Delete Resware Credentials"
                                />
                            }
                            onOpen={() => setCredentialId(props.row.original.id)}
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => {
                                    }}
                                    title="Delete Resware Credentials"
                                    bodyMessage="Are you sure you want to delete this Resware Credential?"
                                    onSubmit={handleDeleteSubmit}
                                    isLoading={deleteApiResponse}
                                />
                            }
                        />
                    </div>
                )
            )
        },
    ];

    return (
        <>
            {hasPermission(["RESW-C"]) && (
                <div className="flex justify-end">
                    <ModalButton
                        triggerButton={
                            <div className="h-7 w-10 text-text-0 rounded-md bg-highlight-0 flex justify-center items-center cursor-pointer  absolute top-0 left-auto">
                                <FaPlus />
                            </div>
                        }
                        modal={
                            <AddEditReswareCredentialsForm
                                show={true}
                                setShow={() => {
                                }}
                                customerId={customerId}
                            />
                        }
                    />
                </div>
            )}

            <div className=''>
                <DataTable
                    columns={columns}
                    actions={{ fetchAction: useSearchReswareCredentialsQuery }}
                    defaultFilter={{ customerId }}
                    appendFilterToUrl={false}
                    basePermission={"RESW"}
                />

                {showCredentialModal && (
                    <AddEditReswareCredentialsForm
                        show={showCredentialModal}
                        setShow={setShowCredentialModal}
                        customerId={customerId}
                        credentialId={credentialId}
                    />
                )}
            </div>
        </>
    );
};

export default ReswareCredentials;
